export default "__VITE_ASSET__a948e8c9__"